import { useState } from "react";
import { saveAmountDisbursement } from "../Api/AmountDisbursement";
import { Container, Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { Accordion, AccordionItem, AccordionBody } from "react-bootstrap";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/ResetButton.css";

const AmountDisbursement = () => {
  const [disbursementData, setDisbursementData] = useState({
    beneficiaryName: "",
    beneficiaryBankDetails: "",
    amountToBeDisbursed: "",
    modeOfPayment: "",
    dateOfDisbursement: "",
    disbursedBy: "",
    remarks: "",
    advanceReqId: ""
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setDisbursementData({
      ...disbursementData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const submissionData = {
      ...disbursementData,
      createdBy: "rohity"
    };

    try {
      await saveAmountDisbursement(submissionData);
      toast.success(`🦄 Amount Disbursement Record Added Successfully`);

      setDisbursementData({
        beneficiaryName: "",
        beneficiaryBankDetails: "",
        amountToBeDisbursed: "",
        modeOfPayment: "",
        dateOfDisbursement: "",
        disbursedBy: "",
        remarks: "",
        advanceReqId: ""
      });

      navigate("/viewDisbursement");
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save disbursement"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">Amount Disbursement</h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">

        <Accordion defaultActiveKey="0" className="asset-master-accordion">
          <AccordionItem eventKey="0">
            <AccordionBody>

              <Row className="g-3">

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="beneficiaryName">
                    <Form.Label>
                      Beneficiary Name <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="beneficiaryName"
                      value={disbursementData.beneficiaryName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="beneficiaryBankDetails">
                    <Form.Label>
                      Beneficiary Bank Details <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="beneficiaryBankDetails"
                      value={disbursementData.beneficiaryBankDetails}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="amountToBeDisbursed">
                    <Form.Label>
                      Amount to be Disbursed <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="amountToBeDisbursed"
                      value={disbursementData.amountToBeDisbursed}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="modeOfPayment">
                    <Form.Label>
                      Mode of Payment <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="modeOfPayment"
                      value={disbursementData.modeOfPayment}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="dateOfDisbursement">
                    <Form.Label>
                      Date of Disbursement <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="dateOfDisbursement"
                      value={disbursementData.dateOfDisbursement}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="disbursedBy">
                    <Form.Label>
                      Disbursed By <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="disbursedBy"
                      value={disbursementData.disbursedBy}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group controlId="remarks">
                    <Form.Label>
                      Remarks <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      value={disbursementData.remarks}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group controlId="advanceReqId">
                    <Form.Label>
                      Advance Request ID <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="advanceReqId"
                      value={disbursementData.advanceReqId}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

              </Row>

            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>

          <Button
            type="button"
            variant="secondary"
            className="fields-reset"
            onClick={() =>
              setDisbursementData({
                beneficiaryName: "",
                beneficiaryBankDetails: "",
                amountToBeDisbursed: "",
                modeOfPayment: "",
                dateOfDisbursement: "",
                disbursedBy: "",
                remarks: "",
                advanceReqId: ""
              })
            }
          >
            Reset
          </Button>

          <Button
            type="submit"
            variant="primary"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Saving…
              </>
            ) : (
              "Save"
            )}
          </Button>

        </div>
      </Form>
    </div>
  );
};

export default AmountDisbursement;